import dotProp from 'dot-prop'
import { getPersistedEntities } from 'selectors/entities'
import underscored from 'underscore.string/underscored'

export const getEntityModel = (ownProps) => `${ownProps.model || ''}.${ownProps.name}`

export const getEntityIdFromState = (state, ownProps) => dotProp.get(state, getEntityModel(ownProps))

export const getEntitiesForSelector = (state, ownProps, { selector, entityName }) => {
  if (selector) return selector.call(null, state)
  return getPersistedEntities(entityName)(state, ownProps)
}

export const mapEntitiesToSelectableOptions = (displayAttribute, valueAttribute) => (entity) => {
  let text = ''
  if (typeof displayAttribute === "function") {
    text = displayAttribute.call(null, entity)
  } else {
    text = entity[displayAttribute]
  }

  let value
  if (typeof valueAttribute === "function") {
    value = valueAttribute.call(null, entity)
  } else {
    value = entity[valueAttribute || "id"]
  }

  return { key: entity.id, value: value, text: text }
}

export const selectableOptionsToTranslated = (selectableOptions, entityName) => {
  const translatableEntityName = underscored(entityName)
  return selectableOptions.map((option) => {
    return { key: option, value: option, text: I18n.t(`api.forms.${translatableEntityName}.options.${option}`) }
  })
}

export const withBlankOption = (optionsToDisplay, includeBlank, translationScope) => {
  if (!includeBlank) return optionsToDisplay
  const blankText = I18n.t(`${translationScope}.blank_option`, { defaultValue: I18n.t('components.semantic_select_field.blank') })
  return [{ key: '', value: '', text: blankText }].concat(optionsToDisplay)
}
